import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { pathChanged } from '../../../redux/actions/nav';
import EventSender, { NavigationEvent } from '../../../services/trackevent';
import getPathParams from '../../../utils/getPathParams';
import queryParamsToObject from '../../../utils/queryParamsToObject';

// TODO: Update this funct to not return anything and call it as a function in App.jsx

const NavListener = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const queryParams = queryParamsToObject(location.search);
    const pathParams = getPathParams(location.pathname);
    const params = {
      ...queryParams,
      ...pathParams,
      path: location.pathname,
    };
    dispatch(pathChanged(location.pathname));
    EventSender.sendEvent(NavigationEvent(params));
  }, [location, dispatch]);

  return null;
};

export default NavListener;
